import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

import { Hardware } from '@data';

export interface FilterAssetsRequest {
  otaJobId?: string;
  organizationId?: string;
  locationId?: string;
  hardware?: string;
  earliestVersion?: string;
  latestVersion?: string;
  pagination?: FilterAssetsPagination;
  searchLinkLabsHardware: boolean;
  isConnected?: boolean;
}

export interface FilterAssetsPagination {
  size: number;
  page: number;
}

export interface FilterAssetsResponse {
  assets: ElasticsearchAsset[];
  total: number;
}

export interface ElasticsearchAsset {
  name?: string;
  mac: string;
  type: EsAssetType;
  hardware: Hardware;
  version: string;
  locationId: string;
  organizationId: string;
  isOnline: boolean;
}

export enum EsAssetType {
  ENTERPRISE = 'ENTERPRISE',
  HOME = 'HOME',
  MANUFACTURING = 'MANUFACTURING',
  UNCLAIMED = 'UNCLAIMED',
}

type NumberToString = { [key: string]: number };

@Injectable()
export class ElasticsearchService {
  constructor(private firebaseFunctions: Functions) {}

  async getAssetVersionAggregate(): Promise<NumberToString> {
    const callable = httpsCallable<void, NumberToString>(this.firebaseFunctions, 'assetsPerFirmwareVersion');
    return (await callable()).data;
  }

  async getOtaJobAssetVersionCount(otaJobId: string): Promise<NumberToString> {
    const callable = httpsCallable<any, NumberToString>(this.firebaseFunctions, 'assetCountForOtaJob');
    return (await callable({ otaJobId })).data;
  }

  async filterAssets(filter: FilterAssetsRequest): Promise<FilterAssetsResponse> {
    const callable = httpsCallable<FilterAssetsRequest, FilterAssetsResponse>(
      this.firebaseFunctions,
      'filterElasticsearchAssets',
    );
    return (await callable(filter)).data;
  }
}
